import React, { useState, useRef, useEffect } from 'react';
import { Checkbox } from 'components/Checkbox/Checkbox';
import './dropdown.css';

export const Dropdown = ({
    label = '',
    options = [],
    type = '',
    onDropdownChange = item => {
        console.log(item);
    },
    selectedOption = [''],
}) => {
    const [isActive, setIsActive] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = e => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsActive(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        !selectedOption?.length && setSelectedCheckboxes(selectedOption);
    }, [selectedOption]);

    const handleDropdownToggle = () => {
        setIsActive(!isActive);
    };

    const handleItemClick = item => {
        setSelectedValue(item);
        setIsActive(false);
        onDropdownChange(item);
    };

    const filterItemClick = item => {
        selectedCheckboxes.includes(item)
            ? setSelectedCheckboxes(prev => prev.filter(el => el !== item))
            : setSelectedCheckboxes(prev => [...prev, item]);
        onDropdownChange(item);
    };

    return (
        <label>
            {label}
            <div
                className={`select-input ${isActive ? '-active' : ''} ${selectedValue ? '-selected' : ''}`}
                ref={dropdownRef}
            >
                <input type="text" />
                <div className="--dropdown__value" onClick={handleDropdownToggle}>
                    <span className="--dropdown__value-text body1">
                        {type === 'filter' ? (
                            selectedCheckboxes.length ? (
                                <p>{selectedCheckboxes.join(', ')}</p>
                            ) : (
                                <div>
                                    <img src={options[0].image} alt={options[0].image} />
                                    {type === 'filter' ? <p className="not-selected">Not selected</p> : options[0].name}
                                </div>
                            )
                        ) : selectedValue ? (
                            <div>
                                {selectedValue?.image && <img src={selectedValue?.image} alt={selectedValue?.name} />}
                                {selectedValue?.name}
                            </div>
                        ) : (
                            <div>
                                <img src={options[0].image} alt={options[0].image} />
                                {options[0].name}
                            </div>
                        )}
                    </span>
                </div>
                <ul>
                    {type === 'filter'
                        ? options.map(el =>
                              type === 'filter' ? (
                                  <li className="body1" onClick={() => filterItemClick(el.name)} key={el.name}>
                                      {el.image && <img src={el.image} alt={el.name} />}
                                      <Checkbox isChecked={selectedCheckboxes.includes(el.name) && true} />
                                      <p className="filter-dropdown-option">{el.name}</p>
                                  </li>
                              ) : (
                                  <li className="body1" onClick={() => handleItemClick(el)} key={el.name}>
                                      {el.image && <img src={el.image} alt={el.name} />}
                                      {el.name}
                                  </li>
                              ),
                          )
                        : options
                              .filter(el => el?.name !== (selectedValue ? selectedValue?.name : options[0].name))
                              .map(el => (
                                  <li className="body1" onClick={() => handleItemClick(el)} key={el.name}>
                                      {el.image && <img src={el.image} alt={el.name} />}
                                      {el.name}
                                  </li>
                              ))}
                </ul>
            </div>
        </label>
    );
};
